var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"course__content py-2 d-flex justify-content-between"},[_c('base-heading',{attrs:{"text":_vm.trans('strings.course_description')}})],1),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.course.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }